import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id 1AC4079F-A8A3-45CB-869D-97DDC3244BF8
 * name invoice-send
 * version: 7.4.47
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/invoice-send.svg
 * tags
 * - Banking 
 * - Shopping 
 */
export const InvoiceSendIcon = createSvgIcon(<><path d="M3 22V3H21V14.26L12 9.76V20L9 22L6 20L3 22M24 18L14 23V19L18 18L14 17V13L24 18Z" /></>, 'InvoiceSendIcon');
export default InvoiceSendIcon